
import Confirm from '@/components/confirm/confirm.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'handleReport',
directives: {
TransferDom
},
components: {
'Confirm': Confirm,
Previewer,
XTextarea,
Group,
Popup
},
data () {
return {
listIndex: 1,
reviewWrap: false,
typeListModel: false,
isDIY: false,
processType: {name: ''},
isConfirmshow: false,
DIYText: '',
confirmtitle: '举报反馈',
confirmconten: '是否确认发送该举报反馈？',
list: [{src: ''}],
options: {
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.previewer-img')[index]
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
},
item: {},
resonList: [],
tel: ''
}
},
created () {
this.getDetail()
this.getResonList()
},
methods: {
getTel () {
var _this = this
var params = new URLSearchParams()
params.append('id', this.$route.query.id)
this.$http({
method: 'post',
url: '/workorder/abuse/phone',
params: params
}).then(res => {
if (+res.code === 100) {
if (res.result) {
_this.tel = res.result
} else {
this.$vux.toast.text('未获取到手机号')
}
} else {
this.$vux.toast.text(res.msg || '未获取到手机号')
}
}).catch(error => {
console.log(error)
})
},
getDetail () {
var _this = this
var params = new URLSearchParams()
params.append('id', this.$route.query.id)
this.$http({
method: 'post',
url: '/workorder/abuse/findById',
params: params
}).then(res => {
this.item = res.result
this.list.length = 0
res.result.url.split(',').forEach(function (element, index) {
_this.list.push({'src': element})
})
}).catch(error => {
console.log(error)
})
},
getResonList () {
this.$http({
method: 'get',
url: '/workorder/abuse/reason'
}).then(res => {
this.resonList = res.result
}).catch(error => {
console.log(error)
})
},
logIndexChange (arg) {
console.log(arg)
},
show (index) {
this.$refs.previewer.show(index)
},
send () {
if (this.processType.name !== '') {
if (this.processType.name === '自定义内容') {
if (this.DIYText === '') {
this.$vux.toast.text('请输入您的自定义举报反馈')
} else {
this.processType.name = this.DIYText
this.isConfirmshow = true
}
} else {
this.isConfirmshow = true
}
} else {
this.$vux.toast.text('请选择您的处理操作')
}
},
confirm () {
var params = new URLSearchParams()
params.append('id', this.$route.query.id)
params.append('status', this.processType.key)
params.append('dealresult', this.processType.name)
params.append('userid', this.item.userid)
this.$http({
method: 'post',
url: '/workorder/abuse/update',
params: params
}).then(res => {
this.$vux.toast.text('该举报已处理成功')
let source = localStorage.getItem('school_source') || '' 
if (source === 'v1') {
this.$router.push({ path: '/todoPage' })
} else if (source === 'v2') {
this.$router.push({ path: '/v2todoPage' })
}
}).catch(error => {
console.log(error)
})
},
confirmProcess (item, index) {
this.typeListModel = false
this.processType = item
if (index + 1 === this.resonList.length) {
this.isDIY = true
} else {
this.isDIY = false
}
}
}
}




// WEBPACK FOOTER //
// ./src/components/handleReport/handleReport.vue